import { Fragment } from 'react';
import { PaginaVendaTemplateProps } from '../PaginaVendaDesktopTemplate';
import * as S from './styles';
import CheckoutContainer from '@/components/molecules/CheckoutContainer';
import Image from 'next/image';
import BreadcrumbPagina from '@/components/molecules/BreadcrumbPagina';

export default function PaginaVendaMobileTemplate(
  props: PaginaVendaTemplateProps,
) {
  const {
    $breadcrumbPageTitle,
    $conteudoDescritivo,
    $bannerDestaqueImagem,
    $valorTotal,
    $funcaoAcaoPrincial,
    $textoBotaoAcaoPrincipal,
    $funcaoAdicionarAoCarrinho,
    $produtoJaFoiAssinado,
  } = props;

  return (
    <Fragment>
      <BreadcrumbPagina $nomePaginaAtual={$breadcrumbPageTitle} />
      <S.ContainerBannerImagem>
        <Image
          src={$bannerDestaqueImagem}
          alt="Banner principal"
          width={360}
          height={200}
          style={{
            objectFit: 'cover',
          }}
        />
      </S.ContainerBannerImagem>
      {$conteudoDescritivo}
      <CheckoutContainer
        $valorTotal={$valorTotal}
        $funcaoAdicionarAoCarrinho={$funcaoAdicionarAoCarrinho}
        $funcaoAcaoPrincial={$funcaoAcaoPrincial}
        $textoBotaoAcaoPrincipal={$textoBotaoAcaoPrincipal}
        $permitirUsuarioRealizarCompra={
          !$produtoJaFoiAssinado && $valorTotal > 0
        }
      />
    </Fragment>
  );
}
